import { ReactElement } from 'react'
//import Bicycle from '../assets/resources/img/Login/bycicle.jpg';
import './Picture.scss';

export const Picture = (): ReactElement => {
  return (
    <div className="stu-login-brand"></div>
  )
}
